<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openDetailPage="openDetailPage"
      @differentCopy="differentCopy"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @add="() => (orderGoodsDialogVisible = true)"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <ChooseOrderGoodsSpecDialog
      :visible.sync="orderGoodsDialogVisible"
      :title="$l('dialog_label_add_order_goods_spec') || '添加订单产品规格'"
      @confirm="onOrderGoodsConfirm"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import ChooseOrderGoodsSpecDialog from '@/views/factory/components/choose-order-goods-spec/dialog.vue'
export default {
  components: {
    PageHeader,
    PageMain,
    ChooseOrderGoodsSpecDialog,
  },
  mixins: [BaseTable, EditLoading],
  data() {
    return {
      usePage: true,
      orderGoodsDialogVisible: false,
      differentCopyCode: '',
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .techInfoListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetailPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'technology-processSheet-detail',
        params: { ...params, pageType },
        query,
      })
    },
    onOrderGoodsConfirm(params) {
      const {
        orderCode,
        productLine,
        orderGoodsSpecCode,
        identifyGoodsName,
      } = params

      if (this.differentCopyCode) {
        this.submitDifferentCopy({
          orderCode,
          productLine,
          orderGoodsSpecCode,
          techCode: this.differentCopyCode,
        })
        return
      }

      this.openDetailPage({
        pageType: 'add',
        params: {
          orderCode,
          productLine,
          orderGoodsSpecCode,
          identifyGoodsName,
        },
      })
    },
    differentCopy(techCode) {
      this.differentCopyCode = techCode
      this.orderGoodsDialogVisible = true
    },
    submitDifferentCopy(params) {
      this.loadingOpen()
      this.$api
        .techInfoDifferentCopyApi(params)
        .then((res) => {
          this.loadingClose()
          const techCode = res.body
          this.openDetailPage({ pageType: 'edit', params: { techCode } })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
  },
}
</script>
